import PubSub from 'underpub-js';
import slick from 'slick-carousel';

var ContentCarousel = function(options) {
  this.options = {
    $el: false,
  };

  this.data = {
    baseClass: 'comp-ContentCarousel',
  };

  $.extend(true, this.options, options);
};

ContentCarousel.prototype.init = function() {
  const self = this;

  self.$slides = self.options.$el.find(`.${self.data.baseClass}__slides`);
  self.$navigationItems = self.options.$el.find(
    `.${self.data.baseClass}__navigation__list__item`,
  );

  self.initSlider();
};

ContentCarousel.prototype.initSlider = function() {
  const self = this;

  self.$slides.slick({
    autoplay: false,
    fade: true,
    speed: 200,
    arrows: false,
    swipe: false,
    adaptiveHeight: true,
  });

  self.$navigationItems.each((index, item) => {
    const $item = $(item);

    $item.on('click', () => {
      self.$slides.slick('slickGoTo', index);
      self.$navigationItems.removeClass('active');
      $item.addClass('active');
    });
  });
};

export default ContentCarousel;
